import { render, staticRenderFns } from "./ImageDragDropUpload.vue?vue&type=template&id=a0ba3acc&scoped=true"
import script from "./ImageDragDropUpload.vue?vue&type=script&lang=js"
export * from "./ImageDragDropUpload.vue?vue&type=script&lang=js"
import style0 from "./ImageDragDropUpload.vue?vue&type=style&index=0&id=a0ba3acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ba3acc",
  null
  
)

export default component.exports